import './About.css';

export default function About() {
  return (
    <section id='section-about' className='section-about'>
      <h1 className='section-heading'>ABOUT ME</h1>
      <div className='container-about'>
        <div className='section-about-background'></div>

        <p className='description-about'>
          Hi, I’m <strong> Prachurya Dash</strong>.
          <br /> A model and an aspiring fashion blogger who’s passionate about
          fashion, blogging, and female entrepreneurship. I hail from
          Bhubaneswar, Odisha, India.
          <br /> At present, I’m pursuing my Bachelors in Business
          Administration from Amity University. I’ve collaborated with various
          brands as their promotional brand model.
          <br />I have an adaptive-flexible personality with communicative
          fluency. In leisure hours- you can find me binge-watching movies, web
          series, and humming to soulful music. Ambitious, Creative, and Chic
          are the words that best describe me.
          <br />
          In the future, being a proud Odia, I would like to work ahead to
          promote Odisha's culture and tourism. I am passionate about most of
          the things I do, and that’s why I excel at them.
          <br /> I consider myself a great company and open to business
          collaborations.
          <br />
          <br />
          Feel free to contact me. I would love to hear from you.
        </p>
      </div>
    </section>
  );
}
